export default "__VITE_ASSET__BNNhETpF__"